import { render, staticRenderFns } from "./customIframe.vue?vue&type=template&id=aaef234a&scoped=true&"
import script from "./customIframe.vue?vue&type=script&lang=js&"
export * from "./customIframe.vue?vue&type=script&lang=js&"
import style0 from "./customIframe.vue?vue&type=style&index=0&id=aaef234a&lang=scss&scoped=true&"
import style1 from "./customIframe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaef234a",
  null
  
)

export default component.exports